import * as NS from './namespace';

const mutations: NS.ISidebarMutations = {
    SET_IS_OPEN: (state, payload) => {
        state.isOpen = payload;
    },
    SET_MENU_REQUEST: (state) => {
        // предзагрузка или нет
    },
    SET_MENU_SUCCESS: (state, payload) => {
        state.menu = payload.user;
        state.adminMenu = payload.admin;
    },
    SET_MENU_FAIL: (state) => {
        // сообщение об ошибке
    },
}

/**
 * Реализация мутаций модуля сайдбара
 */
export default mutations;